import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../useTable";
//UI
import { Checkbox, Input, Textarea, Radio } from "../../ui/inputs/Input";
import { DangerButton, PrimaryButton, SuccessButton, WarningButton } from "../../ui/buttons/Button";
import CatalogoCuentasObras from "../../catalogos/catalogoCuentasObras";
import axios from "axios";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import { formatMoneda, seleccionarCampo, validaMonto, formatoMonto } from "../../util/varios";
import { textAlign } from "@mui/system";

const headCells = [
	{
		id: "codigo",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "SEC.",
		textAlign: "center",
	},
	{
		id: "descripcion",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "PROG.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "SPRO.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "PROY.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "ACT.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "PART.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "GEN.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "ESP.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "SUB.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "ORD.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "CONCEPTO",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "DISPONIBLE Bs.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "MONTO DE LA OBRA",
		textAlign: "center",
	},
];



export default function RegistrarObra(props) {
	var op = require('../../../src/modulos/datos')
	let token = localStorage.getItem('jwtToken');
	const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
	const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
	const [records, setRecords] = useState([]);
	const [activate, setActivate] = useState(false);
	const [mostrar3, setMostrar3] = useState(false);
	const [numProye, setNumproye] = useState(false);
	const [desde, setDesde] = useState(0);
	const [colocaFocus, setColocaFocus] = useState(false);
	const btnAcepta = useRef();
	const btnCancela = useRef();
	const radioObra = useRef();
	const radioServicio = useRef();
	const txtIdObra = useRef();
	const txtDescripcion = useRef();
	const txtDescripcionObra = useRef();
	const txtMontoObra = useRef([]);
	const txtTotalObra = useRef();
	const txtTotalDispo = useRef();

	const [mensaje, setMensaje] = useState({
		mostrar: false,
		titulo: "",
		texto: "",
		icono: "",
	});

	const [filterFn, setFilterFn] = useState({
		fn: (items) => {
			return items;
		},
	});

	const {
		TblContainer,
		TblHead,
		recordsAfterPagingAndSorting,
		TblPagination
	} = useTable(records, headCells, filterFn);

	const salir = () => {
		setRecords([]);
		props.onHideCancela();
		//setTabla(0);
	};

	const handleCloseCatalogoCuentas = () => {
		setMostrar3(false);
	}

	const handleAceptaCatalogoCuentas = (auxiliar, categoria, descripcionaux, monto, proyecto) => {
		setMostrar3(false);
		setNumproye(proyecto);
		txtDescripcion.current.value = descripcionaux;
		/*txtNombreUsuario.current.value = nomPer;
		txtApellidoUsuario.current.value = apePer;
		txtDireccionUsuario.current.value = direPer;
		txtEmailUsuario.current.value = correoPer;
		txtTlfUsuario.current.value = tlf1Per;
		txtCelUsuario.current.value = tlf2Per;
		txtFechaNac.current.value = fnacPer;
		cmbNacionalidad.current.value = nacPer;
		cmbSexo.current.value = sexoPer;
		btnAcepta.current.focus();*/
		seleccionarDetalle(proyecto, auxiliar);
	}

	const catalogoCuentas = (e) => {
		e.preventDefault();
		if (props.operacion === 1 && records.length === 0) {
			setMostrar3(true);
		}

	};

	const seleccionarDetalle = (id, aux) => {

		setActivate(true);

		let endpoint = `${op.conexion}/api/presupuesto/seleccionarctasobrasproye?proyecto=${id}&auxiliar=${aux}&idefiscal=${idefiscal}`
		console.log(endpoint);
		axios.get(endpoint, {
			headers: {
				"x-access-token": `${token}`,
				'Content-Type': 'application/json'

			},
		}).then(function (response) {

			if (response.status == 200) {

				if (response.data.length > 0) {
					let data = [...response.data];
					var totDispo = parseFloat(0.00);
					for (let index = 0; index < data.length; index++) {
						data[index].montoobra = formatoMonto("0,00");
						totDispo += parseFloat(data[index].montoinicial) + parseFloat(data[index].aumentado) - parseFloat(data[index].disminuido) - parseFloat(data[index].comprometido);
					}
					txtTotalDispo.current.value = formatMoneda(totDispo.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
					//setRecords(response.data);
					setRecords(data);
				}

				setActivate(false);

			}

		}).catch(function (error) {

			setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

		}).finally(function () {
			setActivate(false);
		});
	}

	const handleInputMontoChange = (index) => (event) => {
		//event.preventDefault();
		validaMonto(event);
		if (event.target.value === "" || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.0) {
			event.target.value = "0,00";
		}
		if (event.which >= 37 && event.which <= 40) {
			event.preventDefault();
		}
		if (event.which === 13 || typeof (event.which) === 'undefined') {
			/* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
				event.target.value = '0,00'
			} */
			event.target.value = (formatoMonto(event.target.value));
			let char1 = event.target.value.substring(0, 1);
			let char2 = event.target.value.substring(1, 2);
			if (char1 === '0' && char2 !== ',') {
				event.target.value = event.target.value.substring(1, event.target.value.legth);
			}
			let data = [...records];
			let totMonto = parseFloat(0.00);
			let totPag = parseFloat(0.00);
			let totPagUC = parseFloat(0.00);

			//data[index].montodeclarado = event.target.value;
			//data[index].montodeclarado = formatoMonto(event.target.value).replace(/\./g, '').replace(',', '.');



			let dispo = parseFloat(data[index].montoinicial) + parseFloat(data[index].aumentado) - parseFloat(data[index].disminuido) - parseFloat(data[index].comprometido);
			let montoobra = parseFloat(formatoMonto(event.target.value).replace(/\./g, '').replace(',', '.'));
			//let factorCambio = parseFloat(props.factorCambio);
			if (montoobra > dispo) {
				setMensaje({
					mostrar: true,
					titulo: "Advertencia",
					texto:
						"El monto no debe ser mayor al disponible ",
					icono: "error",
				});
				return;
			} else {
				data[index].montoobra = formatoMonto(event.target.value);
			}

			for (let i = 0; i < data.length; i++) {
				totMonto += parseFloat(data[i].montoobra.replace(/\./g, '').replace(',', '.'));
			}
			txtTotalObra.current.value = formatMoneda(totMonto.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
			setRecords(data);
			event.target.value = (formatoMonto(event.target.value));
			if (event.which === 13) {
				if (index + 1 === txtMontoObra.current.length) {
					//txtDeclaradoRef.current[index].focus();
					btnAcepta.current.focus();
					setColocaFocus(true);
				} else {
					txtMontoObra.current[index + 1].focus();
					setColocaFocus(false);
				}
			} else {
				setColocaFocus(false);
			}


		} else if (event.which === 46) {
			return false;
		} else if (event.which >= 48 && event.which <= 57) {
			return true;
		} else if (event.which === 8 || event.which === 0 || event.which === 44) {
			return true;
		} else return false;//alert(e.which);

	};

	const aceptar = () => {
		var sigue = true;
		if (txtTotalObra.current.value.trim() === '0,00') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el Monto de la Obra.', icono: 'informacion' });
			sigue = false;
			txtMontoObra.current[0].focus();
		} else if (txtDescripcionObra.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir la Descripción de la Obra.', icono: 'informacion' });
			sigue = false;
			txtDescripcionObra.current.focus();
		} else if (props.operacion === 3 && props.obra[0].asignada === 1){
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Obra no puede ser Eliminada ya fue Asignada.', icono: 'informacion' });
			sigue = false; 
			btnCancela.current.focus();	
		}
		if (sigue) {
			var cuentas = [];
			var cadMes = [];
			var peri = 0;
			for (let i = 0; i < records.length; i++) {
				cuentas.push({

					idcuenta: records[i].idcuenta,
					montoobra: records[i].montoobra.replace(/\./g, "").replace(",", "."),
					montocuenta: Math.round((parseFloat(records[i].montoinicial) + parseFloat(records[i].aumentado) - parseFloat(records[i].disminuido) - parseFloat(records[i].comprometido)) * Math.pow(10, 4)) / Math.pow(10, 4),

				});
			}
			//setActivate(true);
			let body = {
				//operacion: props.operacion,
				idobra: txtIdObra.current.value,
				tipo: radioObra.current.checked ? 1 : 2,
				idefiscal: idefiscal,
				//fechasis: fechasistema,
				descripcion: txtDescripcionObra.current.value.trim().toUpperCase(),
				cuentas: JSON.stringify(cuentas),
			};
			//alert(JSON.stringify(body))
			actualizarObra(body);
		}

	};

	const actualizarObra = (body) => {
		setActivate(true);
		let endpoint = `${op.conexion}/api/ingenieria/actualizarobra/${props.operacion}`;
		axios
			.post(endpoint, body, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				if (response.status == 200) {
					if (response.data) {
						setActivate(false);
						setDesde(1);
						if (props.operacion === 1) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Obra ha sido registrada de manera satisfactoria.",
								icono: "informacion",
							});
						} else if (props.operacion === 2) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Obra ha sido modificada de manera satisfactoria.",
								icono: "informacion",
							});
						} else if (props.operacion === 3) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Obra ha sido ha sido Eliminada de manera satisfactoria.",
								icono: "informacion",
							});
						}

					}
				}
			})
			.catch(function (error) {
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});
				setActivate(false);
			});
	};

	const cerrarModal = () => {
		setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
		setRecords([]);
		props.onHideCancela();
	};

	return (
		<Modal
			size="lg"
			{...props}
			centered backdrop="static"
			keyboard={false}
			onShow={() => {

				//const anio = moment.utc(fechasistema).format("YYYY");
				if (props.operacion === 1) {
					txtIdObra.current.value = "0";
				} else {
					txtIdObra.current.value = props.obra[0].idobra;
					txtDescripcionObra.current.value = props.obra[0].descripcionobra === null ? "" : props.obra[0].descripcionobra.trim() === "" ? props.obra[0].decrip.trim() : props.obra[0].descripcionobra.trim();
					txtDescripcion.current.value = props.obra[0].descripcionaux;
					if (props.obra[0].tipo === 1){
						radioObra.current.checked = true;
						radioServicio.current.checked = false;
					} else {
						radioObra.current.checked = false;
						radioServicio.current.checked = true;
					}
					var data = [...props.obra];
					let totMonto = parseFloat(0.00);
					var totDispo = parseFloat(0.00);
					for (let index = 0; index < data.length; index++) {
						totMonto += parseFloat(data[index].montoobra);
						totDispo += parseFloat(data[index].montocuenta);
						data[index].montoobra = formatMoneda(data[index].montoobra.toString().replace(',', '').replace('.', ','), ',', '.', 2);
					}
					txtTotalDispo.current.value = formatMoneda(totDispo.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
					txtTotalObra.current.value = formatMoneda(totMonto.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);

					setRecords(data);
				}
			}}
		>
			<Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
				{props.operacion === 1
					? "Agregar Registro de Obra."
					: props.operacion === 2
						? "Editar Registro de Obra."
						: props.operacion === 3
							? "Eliminar Registro de Obra."
							: "Consultar Registro de Obra."}
				{/*<h3 className="fw-bold m-0">Registro de Obras y Servicios</h3>*/}
				<a type="button" className="fw-bold text-light fs-6" onClick={salir}>
					Salir <i className="fa fa-times ms-2"></i>
				</a>
			</Modal.Header>
			<Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap d-flex">
				<div className="col-4 m-0 p-0">
					<Input label="Código:" readOnly ref={txtIdObra} />
				</div>
				<div className="col-4 m-0 ml-auto p-0 pl-2 d-flex gap-2 align-items-center">
					<span className="fw-bold">Tipo:</span>
					<Radio label="Obra" disabled={props.deshabilitado || (props.obra && props.obra[0].asignada === 1)} name='radioTipoObra' ref={radioObra} defaultChecked />
					<Radio label="Servicio" disabled={props.deshabilitado || (props.obra && props.obra[0].asignada === 1)} name='radioTipoObra' ref={radioServicio} />
				</div>
				{props.obra && props.obra[0].asignada === 1 && (
					<div className="col-12 input-group input-group-sm">
						<font color="red" size="1">
							<h1 align="center">
								<i>¡ La Obra está Asignada !</i>
							</h1>
						</font>
					</div>
				)}
				<div className="col-12 m-0 my-2 p-0">
					<Textarea label="Descripción del Proyecto:" readOnly style={{ height: 70 }} ref={txtDescripcion} />
				</div>
				<div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
					<div className="col-3 m-0 p-0">
					</div>
					<div className="col-auto m-0 p-0">
						<PrimaryButton icon='fa-plus m-0'
							onClick={catalogoCuentas} >
						</PrimaryButton>
					</div>
				</div>
				<div className="col-12 m-0 p-0">
					<TblContainer>
						<TblHead />
						<tbody>
							{records &&
								recordsAfterPagingAndSorting().map((item, index) => (
									item.proyecto === '' ? '' :
										<tr key={index} style={{ padding: "0" }}>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.categoria.substring(0, 2)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.categoria.substring(2, 4)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.categoria.substring(4, 6)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.categoria.substring(6, 8)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.categoria.substring(8, 10)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.puc.substring(0, 3)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.puc.substring(3, 5)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.puc.substring(5, 7)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.puc.substring(7, 9)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.auxiliar}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.descripcion}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{formatMoneda((parseFloat(item.montoinicial) + parseFloat(item.aumentado) - parseFloat(item.disminuido) - parseFloat(item.comprometido)).toString().replace(',', '').replace('.', ','), ',', '.', 2)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "right", alignItems: "center" }}
											>
												<input ref={el => txtMontoObra.current[index] = el} disabled={props.deshabilitado} type="text" autoComplete="off" name={item.proyecto} defaultValue={item.montoobra ? item.montoobra : ""} style={{ width: "140px", textAlign: "right", fontSize: "10" }} onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange(index)} onBlur={handleInputMontoChange(index)} className="form-control text-uppercase" />
											</td>
										</tr>
								))}
						</tbody>
					</TblContainer>

				</div>
				<div className="input-group input-group-sm mb-0 col-md-12 px-0">
					<div className='col-md-8'></div>
					<span
						className="input-group-text border-0 bg-transparent"
						id="inputGroup-sizing-sm"
						style={{ fontSize: "12px", fontWeight: 'bold' }}
					>
						TOTAL:
					</span>
					<input
						type="text"
						readOnly
						ref={txtTotalDispo}
						className="form-control form-control-sm border-0 bg-transparent"
						style={{ fontSize: "12px", fontWeight: 'bold', textAlign: "right" }}
						id="inputDispo"
						defaultValue="0,00"
					/>
					<input
						type="text"
						readOnly
						ref={txtTotalObra}
						className="form-control form-control-sm border-0 bg-transparent"
						style={{ fontSize: "12px", fontWeight: 'bold', textAlign: "right" }}
						id="inputObra"
						defaultValue="0,00"
					/>
				</div>

				<div className="col-12 m-0 p-0">
					<Textarea label='Descripción de la Obra:' readOnly={props.deshabilitado || (props.obra && props.obra[0].asignada === 1)} style={{ height: 70, textTransform: "uppercase" }} ref={txtDescripcionObra} />
				</div>
			</Modal.Body>
			<Modal.Footer>
				<SuccessButton ref={btnAcepta} onClick={aceptar}>
					Aceptar
				</SuccessButton>
				<DangerButton ref={btnCancela} onClick={salir}>
					Cancelar
				</DangerButton>
			</Modal.Footer>
			<Mensaje
				mensaje={mensaje}
				onHide={() => {
					mensaje.titulo === "Exito."
						? cerrarModal()
						: setMensaje({
							mostrar: false,
							titulo: "",
							texto: "",
							icono: "",
						});
				}}
			/>
			<CatalogoCuentasObras
				show={mostrar3}
				onHideCancelar={handleCloseCatalogoCuentas}
				onHideAceptar={handleAceptaCatalogoCuentas} />
			<Dimmer active={activate} inverted></Dimmer>
		</Modal>
	);
}
